import { render } from "./CoprarConvert.vue?vue&type=template&id=efe16dfc&scoped=true"
import script from "./CoprarConvert.vue?vue&type=script&lang=js"
export * from "./CoprarConvert.vue?vue&type=script&lang=js"

import "./CoprarConvert.vue?vue&type=style&index=0&id=efe16dfc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efe16dfc"]])

export default __exports__